<template>
  <b-modal :id="modalId" title="Upload File" hide-footer>
    <loading-screen :is-loading="isUploading"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <!-- Preview existing image -->
    <div v-if="existingFileUrl" class="mb-4">
      <h6>Current File:</h6>
      <div class="current-image-preview">
        <p>{{ existingFileUrl }}</p>
        <div class="mt-2 text-center">
          <button class="btn btn-danger btn-sm" @click="removeFile">
            <i class="fas fa-trash"></i> Remove File
          </button>
        </div>
      </div>
    </div>

    <!-- Upload media -->
    <div v-if="!existingFileUrl" class="upload-media">
      <el-upload
        :http-request="uploadFile"
        class="upload-demo"
        drag
        :action="uploadUrl"
        :accept="acceptedFileTypes"
        :file-list="fileList"
        :multiple="false"
        :auto-upload="true"
        :limit="1"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        <div class="el-upload__tip" slot="tip">Only PDF files are allowed</div>
      </el-upload>
    </div>
    <!-- / Upload media -->

    <!-- <div class="mt-3 text-right">
      <button type="button" class="btn btn-light" @click="closeModal">Close</button>
    </div> -->
  </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../../mixins/Forms";

export default {
  name: "UploadWhatsappFileModal",
  mixins: [Forms],
  props: {
    modalId: {
      type: String,
      required: true
    },
    ticketId: {
      type: [String, Number],
      required: true
    },
    existingFileUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isUploading: false,
      serverErrors: [],
      fileList: [],
      acceptedFileTypes: "application/pdf"
    };
  },
  computed: {
    uploadUrl() {
      return `${API_BASE}/tickets/${this.ticketId}/media`;
    }
  },
  methods: {
    handleExceed() {
      this.$notify.warning({
        title: "Warning",
        message: "Only one image can be uploaded at a time"
      });
    },

    uploadFile(params) {
      let vm = this;
      vm.isUploading = true;
      vm.serverErrors = [];

      const formData = new FormData();
      formData.append("file", params.file);

      axios
        .post(vm.uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((r) => {
          vm.isUploading = false;
          vm.$emit("file-uploaded", r.data);
        })
        .catch((e) => {
          vm.isUploading = false;
          vm.setErrors(e);
        });
    },

    removeFile() {
      this.$emit('remove-file');
      this.closeModal();
    },

    closeModal() {
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style scoped>
.upload-media {
  min-height: 200px;
}

.current-image-preview {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}
</style>
